import { randPassword, randUrl, randWord } from '@ngneat/falso';
import {
  ApiWebhookEvent,
  IOrganisation,
  IPractice,
  IUser,
  IWebhook,
  WebhookDisabledReason,
  WebhookStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  DocumentReference,
  Properties,
} from '@principle-theorem/shared';
import { MockDocRef } from '@principle-theorem/testing';

export class WebhookMock
  extends BaseFirestoreMock<
    Properties<
      Omit<IWebhook, 'userRef' | 'consecutiveFailures' | 'disabledReason'>
    >
  >
  implements
    Properties<
      Omit<IWebhook, 'userRef' | 'consecutiveFailures' | 'disabledReason'>
    >
{
  label = randWord();
  endpointUrl = randUrl();
  secret = randPassword();
  events: ApiWebhookEvent[] = [];
  allowedPractices: DocumentReference<IPractice>[] = [];
  status = WebhookStatus.Enabled;
  organisationRef: DocumentReference<IOrganisation> = MockDocRef();
  userRef?: DocumentReference<IUser> = MockDocRef();
  consecutiveFailures?: number = 0;
  disabledReason?: WebhookDisabledReason = undefined;
}
